export const environment = {
  environment: 'production',
  production: true,
  maintenance: false,
  firebase: {
    apiKey: 'AIzaSyBw-6Z_UKL4FClC7oqhyeo7vRXpe65jJ28',
    authDomain: 'forza-281113.firebaseapp.com',
    databaseURL: 'https://forza-281113.firebaseio.com',
    projectId: 'forza-281113',
    storageBucket: 'forza-281113.appspot.com',
    messagingSenderId: '365356080748',
    appId: '1:365356080748:web:dafd3c736dfe88765ec249',
  },
  apiUrl: 'https://api.racebet365.com',
  // D17 card top-up (MasterCard / La Poste through TeleGate's D17 card rail).
  //   wrapperUrl    — the wrapper PAGE we iframe, built per payment as
  //                   `<wrapperUrl>#session=<session_id>` (TeleGate's hosted copy;
  //                   never the gateway's checkout_url, which refuses framing).
  //   wrapperOrigin — the only origin wrapper messages are accepted from and the
  //                   relay target; must be wrapperUrl's origin or the flow is off.
  //   gatewayOrigin — MasterCard's checkout origin: every message from it is
  //                   relayed into the wrapper frame (La Poste credits the wallet
  //                   only when the wrapper reaches the receipt page — see
  //                   d17-card-bridge.ts). Same values in every environment: the
  //                   wrapper is a static page and the gateway is La Poste's.
  telegateD17Card: {
    wrapperUrl: 'https://telegate.tn/embed/d17-card.html',
    wrapperOrigin: 'https://telegate.tn',
    gatewayOrigin: 'https://tnpost.gateway.mastercard.com',
  },
  siteUrl: 'https://racebet365.com',
  talkjsAppID: '1pBkW5nX',
  SUPABASE_URL: 'https://npuxcqiwtzbrulwvwiee.supabase.co',
  SUPABASE_ANON_KEY:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5wdXhjcWl3dHpicnVsd3Z3aWVlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjgzOTgxNzQsImV4cCI6MjA0Mzk3NDE3NH0.QCNSdovTx0k9Sferf9rJj0HNyE7wFenyMdvDalG_Ysc',
  GOOGLE_RECAPTCHA_SITE_KEY: '6LfO_EAsAAAAAIn9Cn6ndB81MdsTUWutT8dYqEdd',

  // Provider gateway (GoldenRace / Softquo virtuals) — the goldenRaceGen2
  // Cloud Run function. PROVIDER_INTEGRATION_ARCHITECTURE.md §4.6 / §11b.
  //   apiUrl         — forza-281113, through the load balancer, the same model
  //                    as test-be: api.racebet365.com's /goldenRace/launch and
  //                    /goldenRace/catalog are routed to goldenRaceGen2
  //                    (rewritten to /launch, /catalog). Only the player routes
  //                    are there; Softquo's wallet webhooks stay on the
  //                    function's own run.app hostname.
  //   launcherOrigin — MUST match the origin of the URL the backend mints, i.e.
  //                    the backend's own GOLDENRACE_LAUNCHER_URL. The two are
  //                    independent configs: whoever rotates that env var has to
  //                    ship a frontend deploy with the new origin in the same
  //                    window, or every launch fails LAUNCH_ORIGIN_MISMATCH.
  //   frameOrigins   — every origin the game DOCUMENT may post from. The launcher
  //                    can hand off to a sibling game host, and only these origins
  //                    are accepted (and replied to) by the postMessage bridge.
  //                    An EMPTY list disables the bridge; it never degrades to '*'.
  //   enabled        — the BUILD-TIME switch only. ON so launch day needs no
  //                    frontend deploy: the section still stays hidden until
  //                    the runtime `virtualsEnabled` setting AND the server's
  //                    per-account verdict (getUserAccount `virtuals`) both say
  //                    yes, and either missing reads as OFF. Set false to force
  //                    it closed regardless of the backend.
  providers: {
    apiUrl: 'https://api.racebet365.com/goldenRace',
    launcherOrigin: 'https://racebet365.hub.softquo.io',
    frameOrigins: ['https://racebet365.hub.softquo.io'],
    enabled: true,
  },
  // Reunion streaming (named Equidia track streams gated by the PMU catalogue): the
  // streamingGen2 Cloud Run function behind api.racebet365.com's /streaming/* route.
  // Read through shared/services/streaming-config.ts by BOTH consumers —
  // ReunionStreamingService (guide, sessions, the public PMU gateway) and
  // TokenInterceptor (which origins get the Firebase token and x-racebet-sec) — so the
  // two can never disagree: on only when `enabled` is true AND `apiUrl` is an http(s)
  // URL. The backend accepts only the origins in its STREAMING_ORIGINS secret
  // (prod: https://racebet365.com). environment.maintenance-prod.ts carries no such
  // key on purpose: the maintenance build keeps the pre-feature player.
  streaming: {
    enabled: true,
    apiUrl: 'https://api.racebet365.com/streaming',
  },
};
